import { render } from "./BaseDesktopNav.vue?vue&type=template&id=109c0ae3&scoped=true"
import script from "./BaseDesktopNav.vue?vue&type=script&lang=js"
export * from "./BaseDesktopNav.vue?vue&type=script&lang=js"

import "./BaseDesktopNav.vue?vue&type=style&index=0&id=109c0ae3&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109c0ae3"]])

export default __exports__